import { mobileMinWidth } from '@/const/const.ts';

const baseSize = 16;
const baseScreenWidth = 560;

const getDesktopFontSize = (clientWidth: number): number => {
  if (clientWidth < 1366) {
    return 14;
  } else if (clientWidth < 1600) {
    return 15;
  } else if (clientWidth < 1920) {
    return 16;
  } else {
    const scale = clientWidth / 1920;
    return Math.min(baseSize * scale, 18);
  }
};

const setRem = () => {
  const clientWidth = document.documentElement.clientWidth;

  if (clientWidth < mobileMinWidth) {
    const scale = clientWidth / baseScreenWidth;
    document.documentElement.style.fontSize =
      baseSize * Math.min(scale, 2) + 'px';
  } else {
    const isDesktop = window.desktopIdentity;

    if (isDesktop) {
      const fontSize = getDesktopFontSize(clientWidth);
      document.documentElement.style.fontSize = fontSize + 'px';
    } else {
      document.documentElement.style.fontSize = '16px';
    }
  }
};

setRem();
window.addEventListener('resize', () => {
  setRem();
});
